import { Box, Button, Flex, HStack, Text, VStack } from '@chakra-ui/react'
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons'
import {
  faArrowDown,
  faTriangleExclamation,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { useState } from 'react'
import { useCallback } from 'react'
import FileDownloader from '../../../components/FileDownloader/FileDownloader'
import FileUploader from '../../../components/FileUploader/FileUploader'
import IconButton from '../../../components/IconButton/IconButton'
import UnderlineHeading from '../../../components/UnderlineText/UnderlineHeading'
import { useLoadingContext } from '../../../utils/hooks/Context/LoadingContext'
import { useRequestStatusContext } from '../../../utils/hooks/Context/RequestStatusContext'
import { useLabels } from '../../../utils/hooks/useLabels/useLabels'
import { REPOSITORY } from './../../../api/repository/Repository'
import ValidationModal from './ValidationModal'
import ConfirmModal from '../../BranchAndCostCenter/subViews/ConfirmModal'
import { useNavigate } from 'react-router-dom'
import { DataLoadError } from '../../../components/DataLoadError/DataLoadError'

const dataLoadErrorColumns = [
  {
    Header: 'Rut',
    accessor: 'sRut',
  },
  {
    Header: 'Mensaje',
    accessor: 'sObserbacion',
  },
]

export default function MassiveTermination() {
  const navigate = useNavigate()
  const [openModal, setOpenModal] = useState(false)
  const { texts } = useLabels()
  const [data, setData] = useState()
  const [validateData, setValidateData] = useState()
  const [valid, setValid] = useState(false)
  const { handleOpen: handleOpenLoading, handleClose: handleCLoseLoading } =
    useLoadingContext()
  const [openConfirm, setOpenConfirm] = useState(false)

  const {
    handleOpen: handleOpenRequest,
    handleSetTitle,
    handleChangeBody,
    handleClose: handleCloseRequest,
  } = useRequestStatusContext()

  const [showDataLoadError, setShowDataLoadError] = useState(false)
  const [dataLoadError, setDataLoadError] = useState()

  const handleOpen = () => {
    setOpenModal(true)
  }
  const handleClose = () => {
    setOpenModal(false)
  }
  const handleFile = useCallback((fileData) => {
    console.log(fileData)
    if (fileData) {
      setData(fileData)
    } else {
      setData([])
    }
  }, [])
  const onOkStatus = useCallback(
    (response, title = null) => {
      handleCLoseLoading()
      handleSetTitle(
        title ? title : 'Colaboradores desvinculados',
        response.status,
      )
      handleChangeBody(
        <Button
          variant="primary"
          onClick={() => {
            handleCloseRequest()
            if (response.status === 200) {
              navigate('/account')
            }
          }}
        >
          {response.status === 200 ? 'Continuar' : 'Contactar a soporte ahora'}
        </Button>,
      )
      handleOpenRequest()
    },
    [handleSetTitle, handleChangeBody, handleOpen, handleCloseRequest],
  )

  const onError = useCallback(
    (response, title = null) => {
      handleCLoseLoading()
      handleSetTitle(
        title ? title : 'Error al editar colaborador',
        response.status,
      )
      handleChangeBody(
        <Button variant="primary" onClick={handleClose}>
          {response.status === 200 ? 'Continuar' : 'Contactar a soporte ahora'}
        </Button>,
      )
      handleOpenRequest()
    },
    [handleSetTitle, handleChangeBody, handleOpen, handleClose],
  )
  const validate = async () => {
    handleOpenLoading()
    setValid(false)
    await REPOSITORY.wsEmpresa.employees
      .validateMassiveTermination(data)
      .then((res) => {
        if (
          Array.isArray(res.data) &&
          res.data.length > 0 &&
          res.data.filter((i) => i?.sObserbacion).length > 0
        ) {
          setDataLoadError(res.data.filter((i) => i?.sObserbacion))
          setValidateData([])
          setShowDataLoadError(true)
          setValid(res.data?.find((i) => !i?.sEmpleado) ? false : true)
        } else {
          setShowDataLoadError(false)
          setDataLoadError([])
          setValidateData(res.data)
          setValid(res.data?.find((i) => !i?.sEmpleado) ? false : true)
          handleOpen()
        }
      })
      .catch(() => {
        setValid(false)
        handleCLoseLoading()
      })
      .finally(() => handleCLoseLoading())
  }

  const handleTermination = async () => {
    onCloseConfirm()
    const data = validateData.map((element) => ({
      sEmpleado: element.sEmpleado,
    }))
    handleOpenLoading()
    await REPOSITORY.wsEmpresa.employees
      .massiveTermination(data)
      .then((res) => {
        handleCLoseLoading()
        onOkStatus(res, res.data.sMensaje)
      })
      .catch((error) => {
        handleCLoseLoading()
        console.log(error)
        onError(error?.response || '', error?.response?.data?.error || '')
      })
  }

  const onOpenConfirm = () => {
    setOpenConfirm(true)
  }
  const onCloseConfirm = () => {
    setOpenConfirm(false)
  }

  return (
    <>
      <ValidationModal
        isOpen={openModal}
        onClose={handleClose}
        data={validateData}
      />
      <VStack alignItems="flex-start" spacing="30px">
        <UnderlineHeading
          variant="h5"
          text="Desvinculación masiva de colaboradores"
        />
        <HStack
          w="100%"
          spacing="22px"
          borderRadius={5}
          padding="10px 10px"
          backgroundColor="#fff"
          border="1px solid #000000"
        >
          <FontAwesomeIcon size="3x" icon={faTriangleExclamation} />
          <VStack spacing={0}>
            <Text variant="warning" w="100%">
              Desvincula a colaboradores de forma masiva mediante un archivo
              excel que debes descargar desde esta página. Una vez descargado se
              debe completar con la información de os colaboradores.
            </Text>
            <Text variant="warning" w="100%">
              Se pueden desvincular hasta 15.000 registros.
            </Text>
          </VStack>
        </HStack>
        <HStack spacing="82px" mt="45px" alignItems="flex-start" pt={50}>
          <FileDownloader
            linkToFile="/files/Amipass_Desvinculacion.xlsx"
            icon={faArrowDown}
          />
          <Flex direction="column">
            <UnderlineHeading variant="h5" text={texts.upload_excel_template} />
            <Box mt="43px">
              <FileUploader handleFile={handleFile} />
            </Box>
          </Flex>
          <Box>
            <Button mt="90px" variant="gray" onClick={validate}>
              Verificar información
            </Button>
          </Box>
        </HStack>
        <Box h="68px" w="310px">
          <IconButton
            variant={'primary'}
            icon={faCircleCheck}
            onClick={onOpenConfirm}
            disabled={!validateData || !valid}
            text="DESVINCULAR SOCIOS"
            border="1px solid #EFA329"
          />
        </Box>
      </VStack>
      <ConfirmModal
        isOpen={openConfirm}
        text={
          'Está a punto de desvincular de forma masiva a varios colaboradores ¿Desea continuar?'
        }
        continueBtn="Desvincular"
        onClose={onCloseConfirm}
        onConfirm={handleTermination}
      />
      <DataLoadError
        data={dataLoadError}
        show={showDataLoadError}
        columns={dataLoadErrorColumns}
        onClose={() => {
          setShowDataLoadError(false)
        }}
      />
    </>
  )
}
